module.exports = __webpack_public_path__ + "img/icon-ok-active.80f1e031.svg";